module.exports = __webpack_public_path__ + "static/media/cq_nuovo_messaggio_ricevuto b.aebd5887.svg";